import React from "react";
import { ControlButtonProps } from "../../../assets/vfx/controls/components";
import { Button as ReactstrapButton } from "reactstrap";

const ExpandButton: React.FC<ControlButtonProps> = ({ className, ...props }) => (
    <ReactstrapButton
        aria-label="Expand row"
        aria-expanded={false}
        {...props}
        className={["action-button", "btn", "expand", "bi-plus-lg", "no-color", "border-0", className]
            .filter(Boolean)
            .join(" ")}
    />
);

export default ExpandButton;